import { api, apiClient } from './index.js';

/**
 * Adds the annotation polygons to the detections.geojson files on s3
 *
 * @async
 * @param {Object} params - The parameters for adding an annotation.
 * @param {string} params.crs - The Coordinate system.
 * @param {string} params.projectUuid - The UUID of the project.
 * @param {string} params.filename - The name of the file to add the annotation.
 * @param {string} params.modelUuid - The UUID of the model.
 * @param {Array|Object} params.polygons - The normalized polygon data for the annotations.
 * @returns {Promise<Object>} The data returned from the API.
 */
export const addAnnotations = async ({ crs, projectUuid, filename, modelUuid, polygons }) => {
	// TODO: when the v2 is removed from the backend, update this
	const { data, error } = await apiClient.post(`/v2/annotations/features`, {
		crs,
		project_uuid: projectUuid,
		model_uuid: modelUuid,
		filename,
		polygons,
	});

	if (error) console.error({ error })

	return data;
};

/**
 * Deletes annotations from the detections.geojson files on s3
 *
 * @async
 * @param {Object} params - The parameters for deleting an annotation
 * @param {string} params.projectUuid - UUID of the project
 * @param {string} params.modelUuid - UUID of the model
 * @param {Array} params.annotationUuids - UUID of the annotations to be deleted
 * @returns {Promise<Object>} The data returned from the API.
 */
export const deleteAnnotations = async ({ projectUuid, modelUuid, annotationUuids }) => {
	// TODO: when the v2 is removed from the backend, update this
	const { data, error } = await apiClient.delete(`/v2/annotations/features`, {
		project_uuid: projectUuid,
		model_uuid: modelUuid,
		annotation_ids: annotationUuids,

	});

	if (error) console.error(JSON.stringify(error, null, 2))

	return data;
};
